export default __webpack_public_path__ + "img/388a7404c8a11abcb973d5d20d63dcaa.png";